import styled from 'styled-components'
import { Popover } from '@headlessui/react'

export const Filter = styled.div`
  margin-left: 16px;
  display: flex;
  align-items: center;

  & > svg {
    margin-right: 8px;
  }

  & > button:not(:last-child) {
    margin-right: 4px;
  }
`
export const SearchAndFilter = styled.div`
  display: flex;
  align-items: center;
`

export const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 10px 10px 10px 0;
  margin: 0 auto;
  margin-top: 30px;
  align-items: center;
  background-color: white;
  border-radius: 100px;
  max-width: 1000px;

  & > p {
    width: 190px;
    font-size: 16px;
    font-weight: var(--font-regular);
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
    position: relative;
    text-align: left;
    padding: 18px 20px 12px 20px;
    top: 5px;

    &.mobile-label {
      display: none;
      padding: 0;
      text-align: left;
      font-size: 16px;
    }

    span {
      position: absolute;
      top: 0;
      font-size: 13px;
      font-weight: var(--font-medium);
    }
  }

  .border-sides {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 1px;
      height: 24px;
      background: #b5bac4;
      display: block;
      transform: translateY(-50%);
    }

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      width: 1px;
      height: 24px;
      background: #b5bac4;
      display: block;
      transform: translateY(-50%);
    }
  }

  & > div {
    margin: 0 20px;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  & > button {
    font-size: 18px;
    border-radius: 100px;
    width: 100px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1000px) {
    width: 100%;
    padding: 20px 5px 20px 0;
    margin: 0;

    p.desktop-label {
      display: none;
    }
    p.mobile-label {
      display: block;
      top: 0;
    }
    > button {
      display: none;
    }
    & > input {
      width: 300px;
    }
    & > div svg {
      width: 18px;
      height: 18px;
    }
  }
`
